import React from 'react';
import { useIntl } from 'react-intl';

import { InputFieldFactory } from 'app/components';

import type { ToDateFieldProps } from './ToDateField.types';

export const ToDateField = ({ value, onChange }: ToDateFieldProps) => {
  const intl = useIntl();

  const handleChange = (event: { name: string; value: string }) => {
    onChange(event.value || null);
  };

  return (
    <InputFieldFactory
      onChange={handleChange}
      field={{
        type: 'date',
        name: 'endDate',
        label: intl.formatMessage({ id: 'reporting.toDate' }),
        fullWidth: false,
        value: value,
        required: false,
        validate: false,
      }}
    />
  );
};
